import { BagsService } from '@/modules/bags/services/bags.service';
import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { DiContainer } from '@/modules/di/di-container';
import { notification } from 'antd';
import { ISearchState } from '../ts/index.types';

const bagsService = DiContainer.get(BagsService);

export const getWheatClass = async (state: ISearchState) => {
  try {
    const data = state.wheatData;
    if (!state || !data)
      return notification.error({
        message:
          'Ошибка автоматического определения класса зерна. Попробуйте, пожалуйста, позже',
      });
    if (!data.sort || !data.type) return;
    const res = await bagsService.getWheatClass({
      idk: String(data?.params?.idk),
      gluten: String(data?.params?.gluten),
      protein: String(data?.params?.protein),
      hfn: String(data?.params?.cp),
      density: String(data?.params?.nature),
      moisture: String(data?.params?.humidity),
      wheat_type: String(indicateWheatType(data?.sort, data?.type)),
    });
    return res.wheat_class;
  } catch (err) {
    return notification.error({
      message:
        'Ошибка автоматического определения класса зерна. Попробуйте, пожалуйста, позже',
    });
  }
};
